import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { each } from 'lodash';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import ProgressBar from '../../../../components/progress-bar';
import { getAccountOpportunities } from '../../SetupActions';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import NumberDisplay from '../../../../components/number-display';
import DateTimeDisplay from '../../../../components/date-time-display';
import OpportunityTable from '../../../Analysic/components/table/opportunity-table';
import QueryExplantionModal from './QueryExplantionModal';
import styles from './styles.css';

function ResultRenderer(props) {
  const { data } = props;
  if (!data) {
    return null;
  }
  const matched = data.is_matched === true;
  return (
    <span className={`text-uppercase label label-${matched ? 'success' : 'danger'}`}>
      <Fa name={matched ? 'check-circle' : 'exclamation-triangle'} /> {matched ? 'passed' : 'failed'}
    </span>
  );
}


class AccountOpportunitiesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      loading: false,
      error: null,
      results: null,
      currentOpportunity: null,
      showModal: false,
    };
    this.getRowClass = this.getRowClass.bind(this);
    this.getExtraColumns = this.getExtraColumns.bind(this);
    this.handleCellClick = this.handleCellClick.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  getRowClass(params) {
    const { node: { data } } = params;
    if (data) {
      if (data.is_matched === false) {
        return styles.rowError;
      }
      if (data.is_matched === true) {
        return styles.rowSuccess;
      }
    }
    return null;
  }

  handleCellClick({ data }) {
    if (data) {
      this.setState({ currentOpportunity: data, showModal: true });
    }
  }

  handleHideModal() {
    this.setState({ showModal: false }, () => {
      this.setState({ currentOpportunity: null });
    });
  }

  getExtraColumns() {
    return [
      {
        colId: 'result',
        headerName: 'Trigger Conditions',
        width: 140,
        hide: false,
        pinned: 'right',
        suppressMiniFilter: true,
        suppressSorting: true,
        suppressMenu: true,
        suppressMovable: true,
        suppressToolPanel: true,
        field: 'is_matched',
        cellRenderer: 'resultRenderer',
        cellStyle: () => ({ cursor: 'pointer' }),
        onCellClicked: this.handleCellClick,
        /*
        valueGetter: this.resultValueGetter,
        cellRendererParams: {
          column: {
            label: 'Submitted Results',
          },
        },
        */
      },
    ];
  }

  loadData() {
    const {
      organization, settings, account, automationId,
    } = this.props;
    if (this.props.opportunities !== null) {
      const results = this.props.opportunities;
      const indexAccounts = results.accounts || {};
      const indexOwners = results.owners || {};
      each(results.opportunities, (opportunity) => {
        opportunity.account = indexAccounts[opportunity.account_id];
        opportunity.owner = indexOwners[opportunity.owner_id];
      });
      this.setState({ error: null, results, loading: false, loaded: true });
    } else if (!this.state.loading) {
      this.setState({ loading: true, loaded: false }, () => {
        this.props.dispatch(getAccountOpportunities(organization._id, account.account_id, settings, automationId))
          .then(
            (results) => {
              // combine
              const indexAccounts = results.accounts || {};
              const indexOwners = results.owners || {};
              each(results.opportunities, (opportunity) => {
                opportunity.account = indexAccounts[opportunity.account_id];
                opportunity.owner = indexOwners[opportunity.owner_id];
              });
              this.setState({ error: null, results, loading: false, loaded: true });
            },
            (e) => {
              this.setState({ results: null, loading: false, loaded: false, error: e.data?.message || e.message });
            },
          );
      });
    }
  }

  renderResults() {
    const { results } = this.state;
    // totalMatched
    // total
    const { totalMatched, total } = results;

    const closeDate = results.lookback ? (<span> closed after <strong><DateTimeDisplay value={results.lookback} format="short" /></strong> </span>) : null;
    const header = (
      <div className="alert alert-default">
        {totalMatched > 0 && <span>Found <NumberDisplay value={results.totalMatched} suffix="opportunity" precision={0} suffixIsUnit /></span>}
        {totalMatched === 0 && <span>No opportunities</span>}
        {closeDate}
        {' '}
        that matched the trigger conditions.
      </div>
    );
    
    let body = null;
    if (total > 0) {
      const height = 400;

      body = (
        <OpportunityTable
          opportunities={results.opportunities}
          tableName="test-account-opportunities-table"
          getRowClass={this.getRowClass}
          columns={this.getExtraColumns()}
          height={height}
          enableFullScreen={false}
          frameworkComponents={{
            resultRenderer: ResultRenderer,
          }}
        />
      );
    } else {
      // mothing found
      body = (
        <div className="alert alert-warning">No opportunities found</div>
      );
    }
    

    return (
      <div>
        {header}
        {body}
        {this.state.currentOpportunity !== null &&
          <QueryExplantionModal
            opportunity={this.state.currentOpportunity}
            show={this.state.showModal}
            settings={this.props.settings}
            onClose={this.handleHideModal}
            automationId={this.props.automationId}
          />
        }
      </div>
    );
  }


  render() {
    const { loading, loaded, error } = this.state;

    if (loading) {
      return (<ProgressBar />);
    }
    if (!loaded) {
      if (error) {
        return (
          <div className="alert alert-danger">{error}</div>
        );
      }
      return null;
    }

    return this.renderResults();
  }
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

AccountOpportunitiesList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  account: PropTypes.shape({
    account_id: PropTypes.string.isRequired,
  }).isRequired,
  settings: PropTypes.shape({}),
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  automationId: PropTypes.string,
  opportunities: PropTypes.shape({
    accounts: PropTypes.shape({}),
    owners: PropTypes.shape({}),
    opportunities: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};
AccountOpportunitiesList.defaultProps = {
  settings: {},
  automationId: null,
  opportunities: null,
};

export default connect(mapStateToProps)(AccountOpportunitiesList);
